module.exports = __webpack_public_path__ + "img/2.744e0b54.png";